var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.228,
    height: 80.146,
    viewBox: "0 0 67.228 80.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M6.918-69.607A49.2,49.2,0,0,0,11.156-48.55a33.265,33.265,0,0,0,11.917,14.1A31.838,31.838,0,0,0,40.95-29.414a39.017,39.017,0,0,0,16.438-3.319,28.441,28.441,0,0,0,11.678-9.658,29.761,29.761,0,0,0,5.079-15.257H62.187a17.071,17.071,0,0,1-6.179,12.717q-5.7,4.72-14.937,4.72-10.517,0-16.357-7.679t-5.84-21.716q0-13.918,5.84-21.536T41.07-98.762q9.319,0,15.038,4.66a16.483,16.483,0,0,1,6.079,12.657H74.145a29.347,29.347,0,0,0-5.059-15.077,28.924,28.924,0,0,0-11.659-9.658A38.521,38.521,0,0,0,40.95-109.56a32.044,32.044,0,0,0-17.937,4.979A33.074,33.074,0,0,0,11.156-90.6,48.793,48.793,0,0,0,6.918-69.607Z",
    transform: "translate(-6.918 109.56)",
    fill: "#090b0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.6fe2a8b66cbfa8e10415d01a0df2fd69.svg";
export { ForwardRef as ReactComponent };